import { render } from "./RemoveUsersFromMyRestaurant.vue?vue&type=template&id=5b16e4bd&scoped=true"
import script from "./RemoveUsersFromMyRestaurant.vue?vue&type=script&lang=js"
export * from "./RemoveUsersFromMyRestaurant.vue?vue&type=script&lang=js"

import "./RemoveUsersFromMyRestaurant.vue?vue&type=style&index=0&id=5b16e4bd&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b16e4bd"]])

export default __exports__